<template>
  <div>
    <header class="siteHeader py-8">
      <div class="container d-flex flex-column flex-md-row justify-content-md-between align-items-center">
        <h1 class="logo d-none d-md-flex"><img class="img-fluid" src="/images/logo.png" alt="Livingstone Cardiology Logo"/></h1>
        <div class="cta-header text-center justify-content-center align-items-center flex-column d-none d-md-flex">
          <p>Get a <strong>quick consultation</strong> today!</p>
          <div class="d-flex">
            <a href="tel:+6596317637" class="cta-call"><span><em>Call Us</em></span></a>
          </div>
        </div>
        <a href="tel:+6596317637" class="cta-mobile w-full text-center d-md-none">Call us at <span>9631 7637</span></a>
      </div>
    </header>
  </div>
</template>

<style scoped>
  .cta-mobile {
    color: white;
    line-height: 20px;
  }
  .siteHeader {
    width: 100%;
    background: black;
    padding: 10px 0;
    position: fixed;
    z-index: 1000;
  }
  .logo {
    font-size: 0;
    line-height: 0;
    margin-bottom: 20px;
  }
  .logo img {
    height: 40px;
  }
  .cta-header p {
    line-height: 20px;
    margin-bottom: 10px;
  }
  .cta-header a {
    font-size: 14px;
    color: white;
    line-height: 20px;
    text-align: center;
    min-width: 120px;
    display: block;
    padding: 10px 0;
    margin: 0 10px;
    border-radius: 4px;
  }
  .cta-whatsapp {
    background: #46aa1e;
  }
  .cta-call {
    background: black;
  }
  .logo-hidden {
    display: none;
  }
  @media (min-width: 576px) {
    .siteHeader {
      position: relative;
    }
  }
  @media (min-width: 768px) {
    .siteHeader {
      background: #f5f5f5;
      padding: 20px 0;
    }
    .logo {
      margin-bottom: 0;
    }
    .logo img {
      height: 54px;
    }
  }
</style>

<script>
export default {
  data () {
    return {
      showlogo: true,
      lastScrollPosition: 0,
    }
  },
  mounted () {
    window.addEventListener('scroll', this.onScroll)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.onScroll)
  },
  methods: {
    onScroll () {
      const currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop
      if (currentScrollPosition < 0) {
        return
      }
      // Stop executing this function if the difference between
      // current scroll position and last scroll position is less than some offset
      if (Math.abs(currentScrollPosition - this.lastScrollPosition) < 60) {
        return
      }
      this.showlogo = currentScrollPosition < this.lastScrollPosition
      this.lastScrollPosition = currentScrollPosition
    }
  }
}
</script>